import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dialogButtonGeneral, dialogSignInUser } from "../../../const/DialogData";
import { labelArrayDialogUserSignIn } from "../../../const/RadioButton/RadioButtonListRadio";
import { ListTabsDialogUserSignIn } from "../../../const/Tabs/Dialog/DialogUser/DialogUserSignIn/ListTabsDialogUserSignIn";
import AvvisoFormMessage from "../../UI/Form/AvvisoFormMessage";
import MessageNoProvider from "../../UI/MessageNoProvider/MessageNoProvider";
import RadioButtonWithTabs from "../../UI/RadiobuttonCustom.js/RadioButtonWithTabs/RadioButtonWithTabs";
import { useTranslation } from "react-i18next";
import { closeDialogUser } from "../../../redux/reducers/dialogUser-reducer";
import useMobileDetection from "../../../Hooks/useMobileDetection";

export default function DialogSignIn({ isOpen = false, returnIsOpen = () => null }) {
  const dialogState = useSelector((state) => state.dialogUser);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const appLoadingState = useSelector((state) => state.appLoader.loading);
  const [isCommitted, setIsCommitted] = useState(false);
  const isMobile = useMobileDetection();

  const commitDialog = () => {
    setIsCommitted(true);
  }

  const closeDialog = () => {
    dispatch(closeDialogUser());
  };

  useEffect(() => {
    returnIsOpen(dialogState.isOpen)
  }, [dialogState])


  return (
    <>
      <Dialog
        open={isOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        fullScreen={isMobile}
        maxWidth={"sm"}
      >
        <DialogTitle>
          {t(dialogSignInUser.DialogTitle)}
        </DialogTitle>
        <DialogContent className="border-Content-dialog">
          <AvvisoFormMessage msg={t("confirmation_email_sent")} />
          <RadioButtonWithTabs
            //GroupName={t("authentication_type")}
            tabPanel={ListTabsDialogUserSignIn(
              isCommitted,
              setIsCommitted
            )}
            labelList={labelArrayDialogUserSignIn}
            startValueReset={labelArrayDialogUserSignIn[0]}
            noTabsComponent={<MessageNoProvider />}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeDialog()}>
            {t(dialogButtonGeneral.Cancel)}
          </Button>
          <Button onClick={() => commitDialog()} variant="contained" disabled={appLoadingState}>
            {t(dialogButtonGeneral.Confirm)}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
